<template>
  <v-container class="pa-0" :class="(adminBatchLoading || instructorBatchLoading) ? 'disabled-pointer' : ''">
    <transition appear name="fade">
      <v-container
        fluid
        d-flex
        align-center
        justify-center
        class="loading-content loading-screen py-0 px-3"
        v-if="!isLoaded"
      >
        <div class="transparency-sheet"></div>
        <div class="loading-block">
          <v-progress-circular
            color="primary"
            :size="70"
            indeterminate
          ></v-progress-circular>
        </div>
      </v-container>
    </transition>
    <v-toolbar
      tabs
      color="primary"
      class="elevation-0"
    >
      <v-toolbar-side-icon>
        <v-icon color="white">video_settings</v-icon>
      </v-toolbar-side-icon>

      <v-toolbar-title>
        <span class="text-white">Batch Settings</span>
      </v-toolbar-title>

      <template v-slot:extension>
        <v-tabs
          v-model="batchSettingsTab"
          grow
          color="transparent"
          slider-color="secondary"
        >
          <v-tab class="white--text">
            Individual Bulbs
          </v-tab>
          <v-tab class="white--text">
            Apply To All
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-container class="batch-tag-list pa-0">
      <v-tabs-items v-model="batchSettingsTab">
        <v-tab-item>
          <v-card
            v-for="(bulb, bulbIndex) in _.orderBy(selectedBulbs, 'id', 'desc')"
            :key="bulb.id"
            id="batch-tags"
            elevation="0"
          >
            <PlaypositBulbSettings
              ref="bulbSettings"
              :key="bulb.id"
              :wrapper-size="800"
              :bulb="bulb"
              :modes="[]"
              :school-listed="school ? school.listed : false"
              :school="school"
              :permission-keys="school && school.permissionKeys ? school.permissionKeys : []"
              :active-color="school ? school.active_color : '#2196F3'"
              :tags="tags"
              :points-available="bulb.points_available"
              :user-type="bulbSettingsUserType"
              :save-bulb-settings="saveBulbSettings"
              :selected-bulb-settings.sync="selectedBulbSettings"
              :is-last-bulb-in-batch="bulbIndex === (selectedBulbs.length - 1)"
              service="batch"
              :api-url="serverURL"
              :token="instructorData.token"
              :timezone="instructorData.timezone"
              @error="handleBulbSettingsError"
              @snackbar="handleSnackbar"
            />
          </v-card>
        </v-tab-item>
        <v-tab-item>
          <PlaypositBulbSettings
            @error="handleBulbSettingsError"
            @snackbar="handleSnackbar"
            @apply-to-all="applyToAll"
            ref="applyAllBulbSettings"
            :wrapper-size="800"
            :bulb="defaultBulb"
            :modes="[]"
            :school-listed="school ? school.listed : false"
            :school="school"
            :permission-keys="school && school.permissionKeys ? school.permissionKeys : []"
            :active-color="school ? school.active_color : '#2196F3'"
            :tags="tags"
            :user-type="bulbSettingsUserType"
            service="batchApplyToAll"
            :api-url="serverURL"
            :token="instructorData.token"
            :timezone="instructorData.timezone"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-container>
  </v-container>
</template>

<script>

import { mapGetters, mapMutations, mapActions, mapState } from 'vuex';
import _ from 'lodash';

export default {
  name: 'BatchSettings',
  props: [ 
    'bulbs',
    'location',
  ],
  data() {
    return {
      renderSettingsCount: 5,
      isLoaded: false,
      batchSettingsTab: 0,
      defaultBulb: {
        keywords: [],
        age: [],
        subject: [],
        proquest: [],
        tags: [],
        config: {
          rewind_yes: 0,
          skip_yes: 0,
          fast_yes: 0,
          retry_yes: 0,
          attempts: 0,
          export_yes: 0,
          mark_yes: 0,
          fast_playback: 0,
        },
        apply_all: {
          rewind_yes: 0,
          skip_yes: 0,
          fast_yes: 0,
          retry_yes: 0,
          export_yes: 0,
          mark_yes: 0,
          fast_playback: 0,
        },
      },
    };
  },
  computed: {
    ...mapGetters([
      'user',
      'school',
      'instructorData',
      'instructorType',
      'serverURL',
      'slideOutLarge',
    ]),
    ...mapGetters('instructors', [
      'tags',
      'instructorBatchLoading'
    ]),
    ...mapGetters('admin', [
      'adminBatchLoading'
    ]),
    bulbSettingsUserType() {
      if (this.instructorType === 'free') return 'freeTeacher';
      else if (this.instructorType === 'pro') return 'premiumTeacher';
      return _.get(this, 'instructorData.isAdmin') ? 'schoolAdmin' : 'schoolTeacher';
    },
    selectedBulbs() {
      return this.bulbs.slice(0, this.renderSettingsCount);
    },
    selectedBulbSettings: {
      get() {
        return this.$store.state['admin/selectedBulbSettings'];
      },
      set(val) {
        this.setSelectedBulbSettings(val);
      }
    },
  }, 
  methods: {
    ...mapActions('admin', [
      'updateAdminBulbSettings',
    ]),
    ...mapActions('instructors', [
      'updateInstructorBulbSettings',
    ]),
    ...mapMutations([
      'slideOut',
      'setDashLoading',
      'triggerSnackbar',
    ]),
    ...mapMutations('admin', [
      'refreshDataAdmin',
      'clearSelectedData',
      'setSelectedBulbSettings',
    ]),
    ...mapMutations('instructors', [
      'refreshData',
    ]),
    closeBatchSettings() {
      this.slideOut({toggle: false, view: null});
    },
    handleSnackbar(snackbarConfig) {
      this.triggerSnackbar(snackbarConfig);
    },
    handleBulbSettingsError(e) {
      this.triggerSnackbar({
        text: e.message,
        color: 'error',
        timeout: 3000,
      });
    },
    saveBulbSettings(bulb) {
      if (this.slideOutLarge.location === 'My-Bulbs' || this.slideOutLarge.location === 'Folders') {
        return this.updateInstructorBulbSettings(bulb);
      } else if (this.slideOutLarge.location === 'Admin-Media-Library') {
        return this.updateAdminBulbSettings(bulb);
      }
    },
    async applyToAll(bulb) {
      try {
        await Promise.all(_.compact(this.$refs.bulbSettings.map((bulbSettingsRef) => _.isFunction(bulbSettingsRef.applyBulb) ? bulbSettingsRef.applyBulb(bulb) : null)));
        this.$refs.applyAllBulbSettings.handlePostApplyToAll({
          success: true,
          reset: true,
        });
      } catch(e) {
        this.$refs.applyAllBulbSettings.handlePostApplyToAll({ error: e });
      }
    },
  },
  watch: {
    batchSettingsTab() {
      this.$store.dispatch('instructors/getTags', {
        searchString: '',
        isSearch: true,
      });
    },
    bulbs (newValue, oldValue) {
      if (oldValue.length === 0 && newValue.length > 0) {
        this.isLoaded = true;
        this.renderSettingsCount = newValue.length;
      }
    }
  },
  created() {
    this.$store.dispatch('instructors/getTags', { isSearch: true });
  },
  mounted() {
    setTimeout(() => {
      this.renderSettingsCount = this.bulbs?.length || 0;
      if (this.bulbs?.length) this.isLoaded = true;
    }, 500)
  },
  destroyed() {
    this.clearSelectedData();
  }
};
</script>

<style>
  #batch-tag {
    height: 100vh;
    overflow-y: hidden;
  }

  .batch-tag-list {
    height: calc(100vh - 112px);
    overflow-y: auto;
    background-color: #FAFAFA;
  }

  #batch-loader {
    height: 5em;
  }

  .disabled-pointer {
    pointer-events: none !important;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }

  .loading-screen {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1000;
    cursor: progress;
  }

  .transparency-sheet {
    position: absolute;
    height: 100vh;
    width: 100%;
    opacity: 0.96;
    background: white;
    transition: all .1 linear;
    display: flex;
    flex-flow: column;
    justify-content: center;
    align-items: center;
    z-index: 3;
  }

  .loading-block {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    max-height: 100%;
    max-width: 100%;
    z-index: 1001;
    text-align: center;
  }
</style>